import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import styles from './productWidget.module.scss'

const defaultKeyFeatureImages = {
  0: `${assetLoader()}/images/KeyFeatures1.svg`,
  1: `${assetLoader()}/images/keyFeatures2.svg`,
  2: `${assetLoader()}/images/keyFeatures3.svg`,
}

const KeyFeatures = ({ keyFeaturesData, isMarginRequired = false, themeClassname }) =>
  keyFeaturesData?.length && (
    <div className={`${styles.keyFeatures} ${isMarginRequired && styles.keyFeaturesNoMargin}`}>
      {keyFeaturesData?.map((item, index) => {
        const keyFeaturesImgUrl = item?.KeyFeatureIcon?.data?.attributes?.url || defaultKeyFeatureImages[index]
        return (
          <div key={`${item}${index}`} className={styles.keyFeaturesMainItem}>
            <Image src={keyFeaturesImgUrl} width={56} height={56} alt={`key-features-${index}`} priority />
            <div className={styles.keyFeaturesValues}>
              <p className={themeClassname}>{item?.keyFeatureHighlight}</p>
              <p className={themeClassname}>{item?.keyFeatureServiceProvided}</p>
            </div>
          </div>
        )
      })}
    </div>
  )

export default KeyFeatures
